var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "880px",
        "show-close": true,
        title: "上传水单",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "box" }, [
        _c(
          "div",
          { staticClass: "step" },
          [
            _c(
              "div",
              { staticClass: "step-item", class: { active: _vm.active > 0 } },
              [
                _c("svg-icon", {
                  attrs: { iconClass: "num-1", className: "icon" },
                }),
                _vm._v(
                  " " +
                    _vm._s(!_vm.typeActive ? "选择客户" : "选择供应商") +
                    " "
                ),
              ],
              1
            ),
            _c("svg-icon", {
              class: { active: _vm.active > 1 },
              attrs: { iconClass: "arrow", className: "icon" },
            }),
            _c(
              "div",
              { staticClass: "step-item", class: { active: _vm.active > 1 } },
              [
                _c("svg-icon", {
                  attrs: { iconClass: "num-2", className: "icon" },
                }),
                _vm._v(" 填写水单信息 "),
              ],
              1
            ),
            _c("svg-icon", {
              class: { active: _vm.active > 1 },
              attrs: { iconClass: "arrow", className: "icon" },
            }),
            _c(
              "div",
              { staticClass: "step-item", class: { active: _vm.active > 2 } },
              [
                _c("svg-icon", {
                  attrs: { iconClass: "num-3", className: "icon" },
                }),
                _vm._v(" 上传附件 "),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active === 1,
                expression: "active === 1",
              },
            ],
          },
          [
            _c(
              "div",
              [
                !_vm.typeActive
                  ? [
                      _c("div", { staticClass: "glasstitle" }, [
                        _vm._v("请选择客户："),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            width: "320px",
                            "margin-top": "32px",
                            "margin-left": "95px",
                          },
                          attrs: { filterable: "", placeholder: "请选择客户" },
                          model: {
                            value: _vm.companyId,
                            callback: function ($$v) {
                              _vm.companyId = $$v
                            },
                            expression: "companyId",
                          },
                        },
                        _vm._l(_vm.companyDrapdown, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.typeActive
                  ? [
                      _c("div", { staticClass: "glasstitle" }, [
                        _vm._v("请选择供应商："),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            width: "320px",
                            "margin-top": "32px",
                            "margin-left": "95px",
                          },
                          attrs: {
                            filterable: "",
                            placeholder: "请选择供应商",
                          },
                          model: {
                            value: _vm.supplierId,
                            callback: function ($$v) {
                              _vm.supplierId = $$v
                            },
                            expression: "supplierId",
                          },
                        },
                        _vm._l(_vm.supplierOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active === 2,
                expression: "active === 2",
              },
            ],
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "formmain",
                attrs: { model: _vm.form, rules: _vm.rules },
              },
              [
                _c("div", { staticClass: "bank" }, [
                  _c("label", { staticClass: "label" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("*")]),
                    _vm._v(" 收款账号"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bank-select", on: { click: _vm.add } },
                    [
                      !_vm.supplyItem.id
                        ? [
                            _c("svg-icon", {
                              attrs: { className: "icon1", iconClass: "add" },
                            }),
                            _c("span", { staticClass: "add" }, [
                              _vm._v("选择账号"),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.supplyItem.id
                        ? [
                            _c("div", { staticClass: "panle" }, [
                              _c(
                                "div",
                                { staticClass: "left" },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      className: "icon",
                                      iconClass: _vm.supplyItem.iconClass,
                                    },
                                  }),
                                  _c("div", { staticClass: "content" }, [
                                    _c("p", { staticClass: "bank-name" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.supplyItem.bankName) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            _vm.supplyItem.currency.toUpperCase(),
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.supplyItem.currency.toUpperCase()
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("p", { staticClass: "bank-name" }, [
                                      _vm._v(
                                        _vm._s(_vm.supplyItem.bankBranchName)
                                      ),
                                    ]),
                                    _c("p", { staticClass: "bank-number" }, [
                                      _vm._v(
                                        _vm._s(_vm.supplyItem.accountNumber)
                                      ),
                                    ]),
                                    _c("p", { staticClass: "address" }, [
                                      _vm._v(
                                        _vm._s(_vm.supplyItem.accountName)
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "right" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "change-account",
                                    on: { click: _vm.add },
                                  },
                                  [_vm._v("更换账号")]
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "付款账户名",
                          prop: "paymentAccountName",
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "320px" },
                          attrs: { placeholder: "请输入付款账户名" },
                          model: {
                            value: _vm.form.paymentAccountName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "paymentAccountName", $$v)
                            },
                            expression: "form.paymentAccountName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "金额", prop: "sourceAmount" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "controls-position": "right",
                            min: 0.01,
                            precision: 2,
                          },
                          on: { change: _vm.sourceAmountChange },
                          model: {
                            value: _vm.form.sourceAmount,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sourceAmount", $$v)
                            },
                            expression: "form.sourceAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "币制", prop: "sourceCurrency" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请选择计算方式", disabled: "" },
                        on: { change: _vm.currencyChange },
                        model: {
                          value: _vm.form.sourceCurrency,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sourceCurrency", $$v)
                          },
                          expression: "form.sourceCurrency",
                        },
                      },
                      _vm._l(_vm.currencyOption, function (item) {
                        return _c("el-option", {
                          key: item,
                          attrs: { label: item, value: item },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "汇率", prop: "exchangeRate" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "320px" },
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.exchangeRate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "exchangeRate", $$v)
                        },
                        expression: "form.exchangeRate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "结算币制", prop: "realCurrency" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "320px" },
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.realCurrency,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "realCurrency", $$v)
                        },
                        expression: "form.realCurrency",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "实际金额", prop: "realAmount" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "320px" },
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.realAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "realAmount", $$v)
                        },
                        expression: "form.realAmount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注", prop: "description" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "675px" },
                      attrs: { placeholder: "请填写备注" },
                      model: {
                        value: _vm.form.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "description", $$v)
                        },
                        expression: "form.description",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active === 3,
                expression: "active === 3",
              },
            ],
          },
          [
            _c(
              "div",
              { staticClass: "view-upload" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      drag: "",
                      action: `/api/SystemFile/uploadFile?source=2`,
                      headers: _vm.header,
                      multiple: false,
                      "file-list": _vm.fileList,
                      "show-file-list": false,
                      data: { source: 2 },
                      "on-success": _vm.handlesuccess,
                      "on-error": _vm.onError,
                      "on-progress": _vm.handlePreview,
                      "on-remove": _vm.handleRemove,
                      "on-exceed": _vm.handleExceed,
                      limit: 1,
                      "before-upload": _vm.beforeUpload,
                    },
                  },
                  [
                    _c("svg-icon", {
                      attrs: { iconClass: "upload", className: "icon" },
                    }),
                    _c("div", { staticClass: "btn" }, [_vm._v("选择文件")]),
                    _c("p", { staticClass: "el-upload__text" }, [
                      _vm._v("只支持图片格式上传"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "file-list" },
                  _vm._l(_vm.fileList, function (item, $index) {
                    return _c("div", { key: $index, staticClass: "panle" }, [
                      _c("div", { staticClass: "left" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/const/constwiimg.png"),
                            width: "32",
                            height: "32",
                          },
                        }),
                        _c("div", { staticClass: "file" }, [
                          _c("p", { staticClass: "file-name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c(
                            "p",
                            { staticClass: "file-size" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("formatterSize")(item.size)) +
                                  " MB "
                              ),
                              _c("el-progress", {
                                staticStyle: {
                                  width: "260px",
                                  "margin-left": "20px",
                                },
                                attrs: {
                                  width: 220,
                                  percentage: _vm.percentage,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "right" }, [
                        _c("i", {
                          staticClass: "el-icon-delete gou",
                          on: { click: _vm.removeFiles },
                        }),
                      ]),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active !== 1,
                  expression: "active !== 1",
                },
              ],
              staticClass: "cancel flex_c_c",
              on: { click: _vm.propbtn },
            },
            [_vm._v(" 上一步 ")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active === 1,
                  expression: "active === 1",
                },
              ],
              staticClass: "cancel flex_c_c",
              on: { click: _vm.propbtn },
            },
            [_vm._v(" 取消 ")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active !== 3,
                  expression: "active !== 3",
                },
              ],
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v(" 下一步 ")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active === 3,
                  expression: "active === 3",
                },
              ],
              staticClass: "ok flex_c_c",
              on: { click: _vm.submit },
            },
            [_vm._v("完成")]
          ),
        ]
      ),
      _c("select-company-bank-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          companyId: _vm.companyId,
          supplierId: _vm.supplierId,
          typeActive: _vm.typeActive,
        },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }